/**
 * Curated IANA timezone list, shared between the Organization forms
 * (source of truth) and the Opportunity form (a consumer that merges in
 * whichever org timezone is actually in play so it always appears in the
 * dropdown, even if it's outside this curated set).
 *
 * The set is short on purpose: continental US zones plus UTC, since the
 * platform is currently authored for US tenants. The IANA id is the source
 * of truth (what gets stored); the label is the human-readable display.
 */
export const US_TIMEZONES = [
    { value: 'America/Denver', label: 'Mountain Time (MT)' },
    { value: 'America/Chicago', label: 'Central Time (CT)' },
    { value: 'America/New_York', label: 'Eastern Time (ET)' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
    { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
    { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
    { value: 'UTC', label: 'UTC' },
];

/**
 * Merge a specific timezone value into the curated list, deduping by IANA
 * id. The value is unshifted to the top so it appears first when present:
 * visually reinforces "this is the relevant org's zone."
 *
 * @param {(string|null)} value
 * @param {Array<{ value: string, label: string }>} [list]
 * @returns {Array<{ value: string, label: string }>}
 */
export function mergeTimezoneOption(value, list = US_TIMEZONES) {
    if (!value) return list;
    if (list.some((tz) => tz.value === value)) return list;
    return [{ value, label: value }, ...list];
}
